// Angular import
import { Component } from '@angular/core';

// project import
import { DOCS_LINK } from 'src/app/app-config';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer {
  docs_link = DOCS_LINK;
}
